import { c as _c } from "react/compiler-runtime";
import CreateFunnelStepModal from 'modules/funnels/funnel/components/create-funnel-step-modal';
import React from 'react';
import { EmptyState } from 'shared/components/empty-states';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
const EmptyFunnelStepList = () => {
  const $ = _c(8);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] !== t) {
    t0 = t("dashboard.funnel.steps.empty.title");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("dashboard.funnel.steps.empty.description");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CreateFunnelStepModal buttonProps={{
      variant: "primary",
      size: "md"
    }} />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0 || $[6] !== t1) {
    t3 = <EmptyState title={t0} description={t1}>{t2}</EmptyState>;
    $[5] = t0;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default EmptyFunnelStepList;